export enum ScormEvents {
  TEST_RESULTS = 'TEST_RESULTS',
  INIT = 'INIT',
  END = 'END',
  ISPRING = 'ISPRING',
}
